import { NFLTeamRanking } from '@pff-consumer/schema'
import { useGetGameTeamGradingQuery } from '../consumer-api'

export const useGetGameTeamGrading = (gameId: number): { data: NFLTeamRanking[]; isLoading: boolean } => {
  const { data = [], isLoading } = useGetGameTeamGradingQuery({ id: gameId })
  return { data, isLoading }
}
